import { css } from '@emotion/core';
import { tokens, media, getCssVariableValue } from '@domain-group/fe-brary';
var colors = tokens.colors;
export var profileDataColours = () => [getCssVariableValue(colors.accentTwo.base.default), getCssVariableValue(colors.accentThree.trim.default), getCssVariableValue(colors.accentFive.base.default), getCssVariableValue(colors.warning.base.default)];
export var occupancyDataColours = () => [...profileDataColours(), getCssVariableValue(colors.accentOne.medium.default)];
export var suburbSummary = /*#__PURE__*/css("display:flex;flex-direction:column;color:", colors.neutral.heavy.default, ";");
export var stats = {
  name: "1i27l4i",
  styles: "display:flex;gap:8px;"
};
export var graphs = /*#__PURE__*/css("display:flex;flex-direction:column;margin-top:16px;gap:16px;", media('>=tablet'), "{flex-direction:row;}");